import IconButton from 'apollo-react/components/IconButton';
import {
  compareNumbers,
  compareStrings,
  createStringSearchFilter,
} from 'apollo-react/components/Table';
import Tooltip from 'apollo-react/components/Tooltip';
import Export from 'apollo-react-icons/Export';
import React from 'react';

import { exportEntity } from '../../../api/entity';
import DatePickerFilter from '../../../components/TableFilters/DatePickerFilter';
import TextFieldFilter from '../../../components/TableFilters/TextInputFilter';
import { useTranslation } from '../../../custom-hooks/useTranslation';
import { createCustomNumberSearchFilter } from '../../../form-designer/utils/controls/ssGrid.utils';
import {
  createCustomCompareDatesForTable,
  createCustomDateFilter,
} from '../../../utils/formHistoryUtils';
import DateCell from '../../CommonTableCells/DateCell';

export const ActionCell = ({ row }) => {
  const translateString = useTranslation();

  const handleClick = async () => {
    const fileName = `${row.SSE_ENTITY_ID}_${translateString('version')}_${row.SSE_VERSION}`;
    await exportEntity({
      entityId: row.SSE_ID,
      fileName,
    });
  };

  return (
    <Tooltip title={translateString('Export')} placement="bottom">
      <IconButton onClick={handleClick} aria-label={translateString('Export')}>
        <Export />
      </IconButton>
    </Tooltip>
  );
};

export const columns = [
  {
    header: 'Version',
    accessor: 'SSE_VERSION',
    sortFunction: compareNumbers,
    filterFunction: createCustomNumberSearchFilter('SSE_VERSION'),
    filterComponent: TextFieldFilter,
  },
  {
    header: 'Status',
    accessor: 'STATUS',
    sortFunction: compareStrings,
    filterFunction: createStringSearchFilter('STATUS'),
    filterComponent: TextFieldFilter,
  },
  {
    header: 'Name',
    accessor: 'SSE_ENTITY_NAME',
    sortFunction: compareStrings,
    filterFunction: createStringSearchFilter('SSE_ENTITY_NAME'),
    filterComponent: TextFieldFilter,
  },
  {
    header: 'Modified By',
    accessor: 'SSE_MODIFIED_BY',
    sortFunction: compareStrings,
    filterFunction: createStringSearchFilter('SSE_MODIFIED_BY'),
    filterComponent: TextFieldFilter,
  },
  {
    header: 'Modified Date',
    accessor: 'SSE_MODIFIED_DATE',
    sortFunction: createCustomCompareDatesForTable,
    customCell: DateCell,
    filterFunction: createCustomDateFilter('SSE_MODIFIED_DATE'),
    filterComponent: DatePickerFilter,
  },
  {
    header: 'Published By',
    accessor: 'SSE_PUBLISH_BY',
    sortFunction: compareStrings,
    filterFunction: createStringSearchFilter('SSE_PUBLISH_BY'),
    filterComponent: TextFieldFilter,
  },
  {
    header: 'Published Comment',
    accessor: 'SSE_PUBLISH_COMMENT',
    sortFunction: compareStrings,
    filterFunction: createStringSearchFilter('SSE_PUBLISH_COMMENT'),
    filterComponent: TextFieldFilter,
  },
  {
    header: 'Release Version',
    accessor: 'SSE_RELEASE_VERSION',
    sortFunction: compareStrings,
    filterFunction: createStringSearchFilter('SSE_RELEASE_VERSION'),
    filterComponent: TextFieldFilter,
  },
  {
    header: 'Release Type',
    accessor: 'SSE_RELEASE_TYPE',
    sortFunction: compareStrings,
    filterFunction: createStringSearchFilter('SSE_RELEASE_TYPE'),
    filterComponent: TextFieldFilter,
  },
  {
    accessor: '',
    customCell: ActionCell,
  },
];
